import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, inject } from 'vue';
import { useRouter } from 'vue-router/composables';
import { VMoney } from 'v-money';

import {
  InputStep,
  SingleInput,
  ShortcutValue,
  BaseText,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { currencyToNumber } from '@/modules/common/helpers/currency';
import { ESuggestedPortfolioBuilderSteps } from '@/modules/wealth/views/SuggestedPortfolioBuilder/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'InitialInvestment',
  setup(__props) {

const router = useRouter();

const changeStep = inject(
  'changeStep',
  (step: ESuggestedPortfolioBuilderSteps) => ({ step })
);
const saveInitialInvestment = inject(
  'saveInitialInvestment',
  (formatted: string, value: number) => ({ formatted, value })
);

const injectInitialInvestmentFormatted = inject(
  'initialInvestmentFormatted'
) as string;

const initialInvestmentFormatted = ref(injectInitialInvestmentFormatted);

const shortcutData = [
  { value: 100, formatted: '+100' },
  { value: 500, formatted: '+500' },
  { value: 1000, formatted: '+1000' },
  { value: 2000, formatted: '+2000' }
];

const initialInvestment = computed(() =>
  currencyToNumber(initialInvestmentFormatted.value)
);
const isDisabled = computed(() => {
  return initialInvestment.value <= 0;
});

function handleChange(event: Event) {
  const target = event.target as HTMLInputElement;
  initialInvestmentFormatted.value = target.value.replace('-', '');
}

function onClear() {
  initialInvestmentFormatted.value = '0,00';
}

function shortcutClick(data: { value: number; formatted: string }) {
  const options = { minimumFractionDigits: 2 };
  const numberFormat = new Intl.NumberFormat('pt-BR', options);

  initialInvestmentFormatted.value = numberFormat.format(
    initialInvestment.value + data.value
  );
}

function onBack() {
  router.push({ name: 'wealthWalletSelection' });
}

function onClick() {
  saveInitialInvestment(
    initialInvestmentFormatted.value,
    initialInvestment.value
  );
  changeStep(ESuggestedPortfolioBuilderSteps.GOAL_DATE);
}

onMounted(() => {
  const textarea = document.querySelector('textarea') as HTMLElement;
  VMoney(textarea, {
    value: {
      decimal: ',',
      thousands: '.',
      prefix: '',
      precision: 2
    }
  });
});

return { __sfc: true,router, changeStep, saveInitialInvestment, injectInitialInvestmentFormatted, initialInvestmentFormatted, shortcutData, initialInvestment, isDisabled, handleChange, onClear, shortcutClick, onBack, onClick, InputStep, SingleInput, ShortcutValue, BaseText, ButtonContainer, ButtonPrimary, NebraskaColors }
}

})